import axiosInstance from 'api/axios';

interface FormDataInput {
  tone: string;
  language: string;
  type: string;
  prompt: string;
}

export const emailGenApi = {
  generateEmail: async (data: FormDataInput): Promise<string> => {
    const response = await axiosInstance.public.post(
      'https://api-fast.kreaitor.ai/api/v1/email-generator/',
      data
    );

    return response.data;
  },
};
